import styled from 'styled-components';
import {colors, devices, fonts} from '../../../utils/styled/_variables.styled';

export const InfiosHeaderMetaNav = styled.nav`
    position: relative;
    display: flex;
    justify-content: flex-end;
    overflow: hidden;

    a {
        font-family: ${fonts.AeonikMono};

        & + a {
            margin-left: 24px;
        }
        &:not(:hover) {
            color: ${props => ((props.blackLetter === "whiteBlack" || props.blackLetter === "transparentBlack") ? colors.infiosGray : colors.white)};
        }
        &:hover,
        &:active {
            color: ${colors.infiosGray};
        }
    }

    ${props => props.isMobile && `
        display: none;
    `}
`;
